<template>
    <div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode"></el-table-column>
            <el-table-column label="合同估算价" prop="htgsj"></el-table-column>
            <el-table-column label="本机预加载情况" >
           
                <template slot-scope="scope">
             
                 {{jzData[scope.$index].jzqk}} 
                </template>
         
            </el-table-column>
            <el-table-column label="预加载" >
                <template slot-scope="scope">
                    <my-btn
                        type="detail"
                        @click="jiaZai(scope.row.bdcodejm)">
                        预加载
                    </my-btn>
                </template>
            </el-table-column>
        </my-table>
         <object id="certMgrObj" classid="CLSID:59B3BFD5-6CC5-4FFA-90E8-C1E5AFCB42E9" width="1" height="1" viewastext> </object>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN, ],
    
    data() {
        return {
            tableData:[],
            jzData:[]
            // jzqk:''
        }
    },
    computed: {
        query() {
            return this.getQuery()
        }
    },
    methods: {
        jiaZai(bdcodejm) {
            this.goto({
                path:'./pwtbwjyjz',
                query: {
                    bdcodejm: bdcodejm,
                }
            })
        },
         checkPdfExit(pdfFileList,bdcode) {
              try {            
             // console.log(pdfFileList);
             certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
             var u = certMgrObj.Util;
              var disHtml="解密投标单位:"+pdfFileList.length;
              var clientDwCount=0;
            for (var m = 0; m < pdfFileList.length; m++)
            { 
               
              var pdfFile=pdfFileList[m].pdfFile;
              pdfFile = pdfFile.replace(/\\/g, '/');
              var strs = pdfFile.split("/");
              var fileName = strs[strs.length - 1];
              var folderName = strs[strs.length - 4] + "\\" + strs[strs.length - 3] + "\\" + strs[strs.length - 2];
              var filePath = u.GetFolderPath(5) + "hbidding" + "\\" + folderName;
                // u.CreateDir(filePath) ; 
              var file = filePath + "\\" + fileName;

    
              if (u.FileExists(file)) //存在文件
              {
                clientDwCount++;
                 // $('#disPdf' + bdcode).html("<font color='green'>有预加载文件</font>");

              } else { //不存在文件

                  //$('#disPdf' + bdcode).html("<font color='red'>未加载完毕</font>");
              }

            }
            disHtml+=";预加载："+clientDwCount;            
            for(var i=0;i<this.jzData.length;i++) {
                    if(this.jzData[i].bdcode==bdcode) {
                        this.jzData[i].jzqk= disHtml
                    }
                }
            // clientDwCount=5;
            if(clientDwCount==pdfFileList.length)
            {
              disHtml="<font color='green'>"+disHtml+"√</font>";
            }
        
    
          }catch (e) {
				alert("失败" + e.message)
			}
          } 
    },     
    created() {
       this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/pwyjzbdlistpwh.json`, 
            {
                zjsqcode: this.getQuery('zjsqcode'),     
            }, 
        data => {
            this.tableData=data.listData
             for(var i=0;i< this.tableData.length;i++) {
              this.jzData.push({bdcode:this.tableData[i].bdcode,jzqk:''})
             }
            
         
            for (var m = 0; m < this.tableData.length; m++) {
                this.checkPdfExit(this.tableData[m].pdfFileList, this.tableData[m].bdcode);
            }
        });
    }
}
</script>

<style scoped lang="scss">

</style>                   